import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    activeTab: 'feed',
    bottomSheetOpen: false,
    bottomSheetContent: null,
    globalLoading: false,
};
const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setActiveTab(state, action) {
            state.activeTab = action.payload;
        },
        openBottomSheet(state, action) {
            state.bottomSheetOpen = true;
            state.bottomSheetContent = action.payload;
        },
        closeBottomSheet(state) {
            state.bottomSheetOpen = false;
            state.bottomSheetContent = null;
        },
        setGlobalLoading(state, action) {
            state.globalLoading = action.payload;
        },
    },
});
export const { setActiveTab, openBottomSheet, closeBottomSheet, setGlobalLoading } = uiSlice.actions;
export default uiSlice.reducer;
